// extracted by mini-css-extract-plugin
module.exports = {"Transfer":"Transfer-module__Transfer___2mis8","section":"Transfer-module__section___3bfNZ"};